<template>
  <div v-if="visible" class="modal-producto-overlay" @click.self="cerrar">
    <div class="modal-producto-content">
      <div class="modal-producto-header">
        <div class="modal-producto-title">
          <span class="modal-producto-codigo">[{{ codigo }}]</span>
          <span class="modal-producto-desc" v-if="descripcion">{{ descripcion }}</span>
        </div>
        <button class="modal-producto-close" @click="cerrar" aria-label="Cerrar"><PhX :size="13" weight="bold" /></button>
      </div>
      <div class="modal-producto-body">
        <ComparadorProducto
          :codigo="codigo"
          :initial-vista="initialVista"
          :hide-search="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ComparadorProducto from './ComparadorProducto.vue'
import { PhX } from '@phosphor-icons/vue'

export default {
  name: 'ModalProducto',
  components: { ComparadorProducto, PhX },
  props: {
    visible: { type: Boolean, required: true },
    codigo: { type: String, default: null },
    descripcion: { type: String, default: '' },
    initialVista: { type: String, default: 'web' },
  },
  emits: ['update:visible', 'close'],
  watch: {
    visible(newVal) {
      document.body.style.overflow = newVal ? 'hidden' : ''
    },
  },
  mounted() {
    this._escHandler = (e) => {
      if (e.key === 'Escape' && this.visible) this.cerrar()
    }
    window.addEventListener('keydown', this._escHandler)
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this._escHandler)
    document.body.style.overflow = ''
  },
  methods: {
    cerrar() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.modal-producto-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1100;
  padding: 40px 20px;
  overflow-y: auto;
}

.modal-producto-content {
  background: var(--color-surface);
  border: 1px solid var(--color-accent-border);
  border-radius: 3px;
  width: 100%;
  max-width: 1200px;
  max-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}

.modal-producto-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: var(--color-surface-3);
  border-bottom: 1px solid var(--color-accent-border);
}

.modal-producto-title {
  display: flex;
  gap: 10px;
  align-items: baseline;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.modal-producto-codigo {
  font-family: var(--font-mono);
  color: var(--color-accent);
  font-weight: 700;
  font-size: 11.5px;
  letter-spacing: 0.05em;
  flex-shrink: 0;
}

.modal-producto-desc {
  font-family: 'Inter', sans-serif;
  color: var(--color-text);
  font-size: 12.5px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal-producto-close {
  background: transparent;
  color: var(--color-text-muted);
  border: 1px solid var(--color-border-strong);
  width: 28px;
  height: 28px;
  border-radius: 2px;
  cursor: pointer;
  font-size: 12px;
  font-family: var(--font-mono);
  flex-shrink: 0;
  margin-left: 16px;
  transition: all 0.15s;
}

.modal-producto-close:hover {
  color: var(--color-danger);
  border-color: var(--color-danger);
}

.modal-producto-body {
  flex: 1;
  overflow-y: auto;
  background: var(--color-background);
}

@media (max-width: 768px) {
  .modal-producto-overlay {
    padding: 0;
  }
  .modal-producto-content {
    border-radius: 0;
    max-height: 100vh;
  }
}
</style>